import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createOption: {
		id: 'polaris-common.fields.connection.edit.option.create-option',
		defaultMessage: 'Create {issueTypeName} {value}',
		description: 'Text for creating a new option in the select',
	},
});
